import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { SharedDocumentType } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

interface GetSharedDocumentTypesResponse {
  data: SharedDocumentType[];
  success: boolean;
}

const getSharedDocumentTypes: QueryFunction<
  SharedDocumentType[],
  ['/shared-document-types']
> = async () => {
  if (isMockServices()) return (await mock(_mockDocumentTypes)).data;
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<GetSharedDocumentTypesResponse>(
    '/shared/document-types',
    {
      method: 'GET',
    },
  );

  if (response.data) {
    return response.data.data.map((docType) => ({
      ...docType,
      fields: [],
    })) as SharedDocumentType[];
  }
  throw new Error('Failed to fetch shared document types');
};

export default getSharedDocumentTypes;

const _mockDocumentTypes: GetSharedDocumentTypesResponse = {
  success: true,
  data: new Array(10).fill(null).map((_, index) => ({
    id: `document-type-${index}`,
    name: `Document Type ${index + 1}`,
    description: `Description for Document Type ${index + 1}`,
    code: `DOC_TYPE_${index + 1}`,
    fields: [],
  })),
};
